import Components from "../../components";

const ForgotPassword = ({ data, dataSetter }) => {
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        title="Şifremi Unuttum"
        safeArea={data?.system?.safeArea}
        pixelRatio={data?.system?.pixelRatio}
      />
      <Components.ForgotPassword
        id="forgot-password"
        label="Forgot Password"
        data={data}
        dataSetter={dataSetter}
      />
    </div>
  );
};

export default ForgotPassword;
